import { useValidateUrl } from "./useValidateUrl";

export const UrlValidator = () => {
	useValidateUrl();

	return null;
};
